const AgencyClients: string = "/firms";

let routes = {
  AgencyClients
};

export default routes;
